import { useDisplayLabel } from '@ps/web-shared-components';
import type { LabelProp } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import inputStyles from '@swf/components/Inputs/RawInput.scss';

import styles from '../Error.scss';

interface Props {
  errorMessage: LabelProp;
  className?: string;
}

const FormatError: React.FC<Props> = ({ errorMessage, className }) => {
  const message = useDisplayLabel(errorMessage);

  return <div className={classNames(styles.message, inputStyles.error, className)}>{message}</div>;
};

export default FormatError;
